var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_10457",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_10457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40003 8.00011L5.80003 5.40011C5.67781 5.27789 5.6167 5.12234 5.6167 4.93345C5.6167 4.74456 5.67781 4.589 5.80003 4.46678C5.92225 4.34456 6.07781 4.28345 6.2667 4.28345C6.45559 4.28345 6.61114 4.34456 6.73337 4.46678L9.80003 7.53345C9.8667 7.60011 9.91392 7.67234 9.9417 7.75011C9.96948 7.82789 9.98337 7.91123 9.98337 8.00011C9.98337 8.089 9.96948 8.17234 9.9417 8.25011C9.91392 8.32789 9.8667 8.40011 9.80003 8.46678L6.73337 11.5334C6.61114 11.6557 6.45559 11.7168 6.2667 11.7168C6.07781 11.7168 5.92225 11.6557 5.80003 11.5334C5.67781 11.4112 5.6167 11.2557 5.6167 11.0668C5.6167 10.8779 5.67781 10.7223 5.80003 10.6001L8.40003 8.00011Z",
    fill: "white",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c52bff2c8d07c50303701df572634a35.svg";
export { ForwardRef as ReactComponent };